module.exports = __webpack_public_path__ + "static/media/social_icon_linkedin.5eb6597a.svg";